import { render, staticRenderFns } from "./WinnersCards.vue?vue&type=template&id=786f0dad&scoped=true"
import script from "./WinnersCards.vue?vue&type=script&lang=js"
export * from "./WinnersCards.vue?vue&type=script&lang=js"
import style0 from "./WinnersCards.vue?vue&type=style&index=0&id=786f0dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786f0dad",
  null
  
)

export default component.exports